import { Box, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import GreenhouseGasEmissionVerifyRemark, {
  GH_GAS_EMISSION_VERIFY_REMARK_ID,
} from './GreenhouseGasEmissionVerifyRemark';
import GreenhouseGasEmissionVerifyForm from './GreenhouseGasEmissionVerifyForm';
import GreenhouseGasEmissionVerifier from './GreenhouseGasEmissionVerifier';

const GreenhouseGasEmissionVerify = () => {
  return (
    <Box mt={2}>
      <Flex gap={1} alignItems={'center'}>
        <Typography fontWeight={800}>
          การจัดการเพื่อลดปัญหาก๊าซเรือนกระจก :
          การทวนสอบปริมาณการปล่อยก๊าซเรือนกระจกของบริษัทในรอบปีที่ผ่านมา
        </Typography>
        <GreenhouseGasEmissionVerifyRemark />
      </Flex>
      <GreenhouseGasEmissionVerifyForm />
      <GreenhouseGasEmissionVerifier />
      <Box id={GH_GAS_EMISSION_VERIFY_REMARK_ID} />
    </Box>
  );
};

export default GreenhouseGasEmissionVerify;
